import { REDUCER_NAME } from './constants';
import { getState as getDomainState } from '../selectors';

export const getState = (state) => getDomainState(state)[REDUCER_NAME];

export const getResults = (state) => getState(state).data;

export const getIsFetching = (state) => getState(state).isFetching;

export const getHasNext = (state) => getState(state).nextCursor != null;

export const getHasPrev = (state) => getState(state).prevCursor != null;

export const getNextCursor = (state) => getState(state).nextCursor;

export const getPrevCursor = (state) => getState(state).prevCursor;

export const getFilters = (state) => getState(state).filters;

export const getIsCancelling = (state) => getState(state).isCancelling;

export const getIsUpdatingRecipient = (state) => getState(state).isUpdatingRecipient;

export const getIsUpdateRecipientScreenOpened = (state) => getState(state).isUpdateRecipientScreenOpened;
